import styles from './index.module.scss'
import Utils from '@utils/utils'
import { Button } from 'antd'
import { GenerateContext } from '../../../hooks/GenerateContext'
import { useContext } from 'react'


const FUSION_WEAR_SAMPLE_URL = "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/fusionWear/";

// 每组对应的小图数量
const SMALL_IMAGE_COUNTS = [2, 2, 2, 4, 2, 2, 3, 3, 3, 1];
const promptList = [
    "随机生成一个亚洲年轻女模特, 正面拍摄全身, 背景在街头咖啡店外, 初冬季节, 少量积雪, 姿势身体微微侧转, 一手插在羽绒服口袋里, 另一手捧着咖啡杯自然垂在身侧, 步伐放松, 头部轻转向右侧, 姿态舒展又随性, 穿上图1中的米白色羽绒服, 穿上图2中的米色竖条纹高领针织连衣裙。",
    "随机生成一个亚洲年轻女模特, 背景在冬日雪山湖畔，覆雪山脉连绵，山下嵌着湖泊，厚雪覆地面，天泛柔光，清冷开阔, 姿势侧身站立，身体微微转向镜头，双手轻握在胸前（拢住衣服领口），头部稍低、视线向前，姿态放松又带着随性的酷感, 穿上图1中的浅蓝色带毛领羽绒服，戴上图2中的白色针织毛线帽配毛绒球。",
    "随机生成一个亚洲年轻女模特, 背景在覆雪山野：雪盖山峦连绵，林间松枝积白，天地铺展厚雪，氛围清冽开阔，姿势正行走在雪地中，侧身迈步，一手自然垂落，头部转向镜头露笑，发丝轻扬，姿态松弛又灵动, 穿上图1中的米色绗缝连帽羽绒服，穿上图2中的黑色高腰阔腿裤。",
    "随机生成一个欧洲年轻女模特, 背景在城市街巷：红砖建筑林立，街道铺石砖，车辆停靠路边，行人穿梭，光线明亮柔和, 模特正沿人行道行走，一手插裤袋，身体微侧，步伐舒展，姿态优雅随性, 穿上图1中的米色休闲西装外套，穿上图2中的米白色丝质系带衬衫，穿上图3中的米色垂感阔腿裤，穿上图4中的米色皮革尖头高跟鞋。",
    "随机生成一个年轻东亚女性模特, 背景在夜晚城市街道：临街店铺亮灯，路面铺展，路灯与建筑灯光交织，氛围潮酷随性,模特站于街边，一手拎图2中的黑色猫眼太阳镜抬至肩侧，左手插在牛仔裤口袋，露出腰腹线条，身体微微倾斜朝向镜头，穿上图1中的米白色条纹运动夹克。",
    "随机生成一个中国年轻女模特, 背景在商场内：店铺林立，灯光明亮，货架陈列商品，氛围整洁轻快, 模特正对前方手持手机自拍，身体微侧，视线看向镜头，姿态自然松弛, 穿上图1中的浅蓝色竖条纹系带衬衫，右肩背上图2中的白色皮革手提包。",
    "模特穿上图1中的黑白千鸟格纹西装外套，戴上图2中的黑色猫眼太阳镜，穿上图3中的黑色阔腿牛仔裤。",
    "随机生成一个美洲金发男性模特, 背景在海滨白色岩石地貌：大片白色岩石错落分布，远处可见海岸线与低缓山丘，天空晴朗湛蓝，光线明亮，呈现出地中海风格的度假氛围, 模特斜靠在岩石上，身体放松，一手搭于身侧岩石，另一只手搭右腿上，姿态随性自然。侧方平视角度近景，突出穿搭与人物状态，光线利用自然光影增强画面层次感。穿上图1中的米色棉质长袖衬衫，穿上图2中的米白色垂感休闲长裤，戴上图3中的黑色方形太阳镜。",
    "随机生成一个欧美男性模特, 背景在复古奢华室内：深绿墙面饰金色雕花，搭配酒红色丝绒沙发，氛围典雅贵气, 模特坐于沙发，一手搭扶手，一手放腿间，身体微靠，姿态沉稳利落, 穿上图1中的深绿色印花西装套装，穿上图2中的棕色皮质系带正装鞋，戴上图3中的黑色方形太阳镜。",
    "模特穿上图1中的米色缎面抹胸长礼服。",
]

const DefaultPage = () => {
    const { setMatchImages, setPrompt, setModelImage } = useContext(GenerateContext)
    const doSame = (index) => {
        if (index === 7 || index === 10) {
            setModelImage([{ url: FUSION_WEAR_SAMPLE_URL + `${index}-model.png` }])
        } else {
            setModelImage([])
        }
        setMatchImages([...Array.from({ length: SMALL_IMAGE_COUNTS[index - 1] }).map((_, subIndex) => (
            { url: FUSION_WEAR_SAMPLE_URL + `${index}-${subIndex + 1}.png` }
        ))])
        setPrompt(promptList[index - 1])
    }

    return (
        <div className={styles.DefaultPage}>
            <p className={styles.DefaultPageTitle}><span>低成本测款</span>种草素材马上就位</p>
            <div className={styles.sampleWrap}>
                {Array.from({ length: 10 }).map((_, index) => (
                    <div
                        key={`sample_${index}`}
                        onClick={() => doSame(index + 1)}
                        className={`${styles.sampleItem}`}
                    >
                        <img className={styles.sampleImg} src={Utils.getImgThumbnail(FUSION_WEAR_SAMPLE_URL + `${index + 1}.png`)} alt="" />
                        <div className={styles.smallSampleWrap}>
                            {Array.from({ length: SMALL_IMAGE_COUNTS[index] }).map((_, subIndex) => (
                                <img
                                    key={`small_${index}_${subIndex}`}
                                    className={styles.smallSampleImg}
                                    src={Utils.getImgThumbnail(FUSION_WEAR_SAMPLE_URL + `${index + 1}-${subIndex + 1}.png`)}
                                    alt=""
                                />
                            ))}
                            {
                                (index === 6 || index === 9) &&
                                <img
                                    className={styles.smallSampleImg}
                                    src={Utils.getImgThumbnail(FUSION_WEAR_SAMPLE_URL + `${index + 1}-model.png`)}
                                    alt=""
                                />
                            }
                        </div>
                        <Button
                            type="primary"
                            className={styles.doSameBtn}
                        >
                            做同款
                        </Button>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default DefaultPage